import React from 'react';

const JurisdictionsDisclaimers = () => (
	<div className="container main">
		<h2>Disclaimers</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>Canada</h4>
				<p>
					The scope of Canada's consumer products recall notifications involves consumer products defined under the Canada Consumer Product Safety Act (CCPSA) as "a product,
					including its components, parts or accessories, that may reasonably be expected to be obtained by an individual to be used for non-commercial purposes,
					including for domestic, recreational and sports purposes, and includes its packaging." 
				</p>
				<p>
					It also involves cosmetic products.  The term “cosmetic” is defined under the Food and Drugs Act (FDA),
					as "any substance or mixture of substances, manufactured, sold or represented for use in cleansing, improving or altering the complexion, skin, hair or teeth
					and includes deodorants and perfumes."
				</p>
				<p>Areas which are not within the scope of Canada's consumer and cosmetic product recall notifications include:</p>
				<ul>
					<li>Explosives within the meaning of section 2 of the Explosives Act.</li>
					<li>Devices within the meaning of section 2 of the Food and Drugs Act.</li>
					<li>Drugs within the meaning of section 2 of the Food and Drugs Act.</li>
					<li>Pest control products within the meaning of subsection 2(1) of the Pest Control Products Act.</li>
					<li>Vehicles within the meaning of section 2 of the Motor Vehicle Safety Act and a part of a vehicle that is integral to it — as it is assembled or altered before its sale to the first retail purchaser — including a part of a vehicle that replaces or alters such a part.</li>
					<li>Feeds within the meaning of section 2 of the Feeds Act.</li>
					<li>Fertilizers within the meaning of section 2 of the Fertilizers Act.</li>
					<li>Vessels within the meaning of section 2 of the Canada Shipping Act, 2001.</li>
					<li>Firearms within the meaning of section 2 of the Criminal Code.</li>
					<li>Ammunition within the meaning of subsection 84(1) of the Criminal Code.</li>
					<li>Cartridge magazines within the meaning of subsection 84(1) of the Criminal Code.</li>
					<li>Cross-bows within the meaning of subsection 84(1) of the Criminal Code.</li>
					<li>Prohibited devices within the meaning of paragraphs (a) to (d) of the definition prohibited device in subsection 84(1) of the Criminal Code.</li>
					<li>Plants within the meaning of section 3 of the Plant Protection Act, except for Jequirity beans (abrus precatorius).</li>
					<li>Seeds within the meaning of section 2 of the Seeds Act, except for Jequirity beans (abrus precatorius).</li>
					<li>Controlled substances within the meaning of subsection 2(1) of the Controlled Drugs and Substances Act.</li>
					<li>Aeronautical products within the meaning of subsection 3(1) of the Aeronautics Act.</li>
					<li>Animals within the meaning of subsection 2(1) of the Health of Animals Act.</li>
				</ul>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>European Commission</h4>
				<p>If not specified in the Safety Gate / RAPEX alert, the risk refers to the risk to consumers' health and safety.</p>
				<p>As of 2010, the alerts also include measures taken against professional non-food products and against non-food products posing other risks, such as a security risk or a risk to the environment.</p>
				<p>Since 2019, alerts which were previously circulated only for information among national authorities, are also published on the website, if that is deemed necessary by the national authority.</p>
				<p>Proprietary brands, designs and logos that appear in this listing may have been used by economic operators in violation of intellectual property rights and thus without the legitimate owner's knowledge and/or permission.</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>Japan</h4>
				<p>The scope of our recall notifications includes consumer products, such as home electric appliances, household goods, stationery and entertainment products, and others. It excludes food products, vehicles, and pharmaceuticals (including cosmetics).</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>United States</h4>
				<p>
					The Consumer Product Safety Commission has jurisdiction over many types of consumer products, from coffee makers,
					to toys, to lawn mowers, to fireworks. However, some types of consumer products are covered by other Federal agencies.
					Please see this list of products covered by other agencies:
					<a href="https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/" target="_blank">https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/</a>.
				</p>
			</div>
		</div>
		<hr/>
	</div>
);

export default JurisdictionsDisclaimers ;



// WEBPACK FOOTER //
// ./src/views/static/en/jurisdictions-disclaimers.js